// extracted by mini-css-extract-plugin
export default {"root":"LoadingOverlay-module__root","button":"LoadingOverlay-module__button","spinner":"LoadingOverlay-module__spinner","shown":"LoadingOverlay-module__shown"};